module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container page-notfound"
  }, [_c('div', {
    staticClass: "hero is-medium is-primary"
  }, [_c('div', {
    staticClass: "hero-body content"
  }, [_c('div', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          Uh oh\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n          404 Page Not Found\n        ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-446b0d98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound.vue
// module id = 738
// module chunks = 1